module.exports = __webpack_public_path__ + "static/media/arrow.60e9c61e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/arrow.svg
// module id = 263
// module chunks = 1